import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { EditDraftFinancialDocumentFormSchemaValues } from 'src/features/financialDocuments/utils/formSchema';
import { FinancialDocument } from 'src/features/financialDocuments/utils/types';

const RESOURCE = '/financial-documents/financial-document/:documentId/';

type MutationFnType = typeof mutationFn;

interface DTO extends EditDraftFinancialDocumentFormSchemaValues {
    documentId: string;
}
const mutationFn = ({ documentId, ...data }: DTO): Promise<FinancialDocument> => {
    return axios.put(formatResourcePath(RESOURCE, { documentId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateFinancialDocument };
